import { MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { Fragment } from "react";
import { neighborhoods } from "@/data/neighborhoods";

const linkedSlugs = new Set(neighborhoods.map((n) => n.slug));

const areas: Array<{ name: string; slug?: string }> = [
  { name: "Nashville", slug: "nashville" },
  { name: "Green Hills", slug: "green-hills" },
  { name: "Brentwood", slug: "brentwood" },
  { name: "Franklin", slug: "franklin" },
  { name: "Belle Meade", slug: "belle-meade" },
  { name: "Bellevue", slug: "bellevue" },
  { name: "Mt. Juliet", slug: "mount-juliet" },
  { name: "Murfreesboro" },
  { name: "Nolensville" },
  { name: "Spring Hill" },
  { name: "Smyrna" },
  { name: "La Vergne" },
];


const AreasServed = () => {
  return (
    <section className="py-16 md:py-20 bg-background">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-accent mb-4">
            <MapPin className="h-5 w-5 text-accent-foreground" />
          </div>
          <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-warm-ink mb-3 font-medium">Where We Serve</p>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold mb-6">
            Areas We Serve
          </h2>
          <div className="w-16 h-px bg-warm mx-auto mb-8" />
          <p className="text-foreground/75 mb-6 font-light leading-relaxed max-w-2xl mx-auto">
            Proudly serving Davidson and Williamson County — Nashville and its surrounding communities — with the same standard of excellence, wherever you call home.
          </p>
          <p className="flex flex-wrap items-center justify-center gap-x-1 gap-y-2 text-foreground/85 font-light leading-relaxed text-base md:text-lg max-w-2xl mx-auto">
            {areas.map((area, i) => (
              <Fragment key={area.name}>
                {i > 0 && <span className="text-foreground/30 mx-1">·</span>}
                {area.slug && linkedSlugs.has(area.slug) ? (
                  <Link
                    to={`/areas/${area.slug}`}
                    className="text-foreground hover:text-warm-ink underline underline-offset-4 decoration-warm-ink/50 transition-colors"
                  >
                    {area.name}
                  </Link>
                ) : (
                  <span>{area.name}</span>
                )}
              </Fragment>
            ))}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AreasServed;
